import RFIsAdmin from './RFIsAdmin';

export default RFIsAdmin;
